import configuration from "../../config";
import database from "../../firebase";
import { onValue, ref, child, get } from "firebase/database";
import React, { useState, useRef, useEffect } from "react";
import { Map, GoogleApiWrapper, Marker, InfoWindow } from "google-maps-react";
import { toast } from "react-toastify";
import { getAccessRights } from "../../utils/common";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../components/Loader/Loader";

const MapContainer = ({ google }) => {
  let defaultProps = {
    center: {
      lat: 23.0225,
      lng: 72.5714,
    },
    zoom: 12,
  };
  const [drivers, setDrivers] = useState([]);
  const reference = useRef(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [liveTripData, setLiveTripData] = useState([]);
  const [selectedElement, setSelectedElement] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const history = useHistory();

  const notificationMethods = [
    { id: "all", title: "All Drivers" },
    { id: "online", title: "Online Drivers" },
    { id: "offline", title: "Offline Drivers" },
    { id: "ongoing", title: "Ongoing Drivers" },
  ];

  function OnMarkerClick(e, marker, element) {
    setIsLoader(true);
    configuration
      .getAPI({
        url: "passenger/detail",
        params: { user_id: element.driver_id },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setSelectedElement(data.payload);
          setActiveMarker(marker);
        } else {
          setIsLoader(false);
          setSelectedElement();
          setActiveMarker();
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
    configuration
      .getAPI({
        url: "driver/ongoing",
        params: { driverID: element.driver_id },
      })
      .then((data) => {
        if (data.status === 200) {
          setLiveTripData(data.payload);
        } else {
          setLiveTripData([]);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "LIVE_TRIPS");
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });
    // const auth = getAuth();
    // signInAnonymously(auth)
    //   .then((userCredential) => {
    //     setDriverInterval("online");
    //   })
    //   .catch((error) => {
    //     const errorCode = error.code;
    //     const errorMessage = error.message;
    //   });
    // const driversRef = ref(database, "drivers");
    // const unsubscribe = onValue(driversRef, (snapshot) => {
    //   const data = snapshot.val();
    //   if (data) {
    //     const driverList = Object.keys(data).map((id) => ({
    //       // id,
    //       // ...data[id],
    //       driver_id: id,
    //       lat: parseFloat(data[id].latitude),
    //       lng: parseFloat(data[id].longitude),
    //       status: data[id].status,
    //       name: data[id].name,
    //       vehicle_type: data[id].vehicle_type,
    //     }));
    //     console.log(driverList, "driverListdriverList");
    //     setDrivers(driverList);
    //   }
    // });

    // return () => unsubscribe(); // cleanup on unmount
    getLiveData("all");
  }, []);

  // function setDriverInterval(type) {
  //   if (type === "ongoing") {
  //     configuration
  //       .getAPI({ url: "driver/ongoing", params: {} })
  //       .then((data) => {
  //         if (data.status === 200) {
  //           console.log(data.payload);
  //           // setIntervalData(
  //           //   setInterval(() => {
  //           //     getOngoingDriver(data.payload);
  //           //   }, 3000)
  //           // );
  //         }
  //       })
  //       .catch((error) => {
  //         return toast.error(error.message);
  //       });
  //   }
  // }
  function getLiveData(type) {
    setIsLoader(true);
    const driversRef = ref(database, "drivers");

    onValue(driversRef, (snapshot) => {
      const driversData = snapshot.val();

      if (!driversData) {
        setDrivers([]);
        return;
      }

      if (type === "ongoing") {
        setIsLoader(false);
        const assignedTripsRef = ref(database, "assigned_trips");

        onValue(assignedTripsRef, (assignedSnapshot) => {
          const tripsData = assignedSnapshot.val() || {};

          const assignedDriverIds = new Set(
            Object.keys(tripsData).map((trip) => trip)
          );
          const filteredDrivers = Object.keys(driversData)
            .filter((id) => assignedDriverIds.has(id))
            .map((id) => ({
              driver_id: id,
              lat: parseFloat(driversData[id].latitude),
              lng: parseFloat(driversData[id].longitude),
              status: driversData[id].status,
              name: driversData[id].name,
              vehicle_type: driversData[id].vehicle_type,
            }));

          setDrivers(filteredDrivers);
        });
      } else {
        setIsLoader(false);
        const filteredDrivers = Object.keys(driversData)
          .filter((id) => type === "all" || driversData[id].status === type)
          .map((id) => ({
            driver_id: id,
            lat: parseFloat(driversData[id].latitude),
            lng: parseFloat(driversData[id].longitude),
            status: driversData[id].status,
            name: driversData[id].name,
            vehicle_type: driversData[id].vehicle_type,
          }));

        setDrivers(filteredDrivers);
      }
    });
  }

  function changeDriver(e, type) {
    getLiveData(type);
  }

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <div className="bg-gray-50 flex flex-col justify-center">
        <div className="grid grid-cols-1 md:grid-cols-1 ">
          <div className=" py-4 px-4 shadow-lg bg-white">
            <div>
              <fieldset className="mt-4">
                <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                  {notificationMethods.map((a) => (
                    <div key={a.id} className="flex items-center">
                      <input
                        id={a.id}
                        name="notification-method"
                        type="radio"
                        onClick={(e) => changeDriver(e, a.id)}
                        defaultChecked={a.id === "all"}
                        className="focus:ring-indigo-600 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer"
                      />
                      <label
                        htmlFor={a.id}
                        className="ml-3 block text-basefont-medium text-gray-700 cursor-pointer"
                      >
                        {a.title}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
          </div>
          <div className="relative h-screen w-full">
            <Map
              google={google}
              initialCenter={{
                lat: defaultProps.center.lat,
                lng: defaultProps.center.lng,
              }}
              zoom={defaultProps.zoom}
            >
              {/* set markers for orders */}
              {drivers?.map((element, index) => {
                return (
                  <Marker
                    key={index}
                    ref={reference}
                    title={element.name}
                    position={{
                      lat: element?.lat,
                      lng: element?.lng,
                    }}
                    icon={{
                      url:
                        element.status === "online"
                          ? element.vehicle_type === "bike"
                            ? "image/onBike.png"
                            : "image/onpin.png"
                          : element.vehicle_type === "bike"
                          ? "image/offBike.png"
                          : "image/offpin.png",
                      anchor: new google.maps.Point(30, 45),
                      scaledSize: new google.maps.Size(30, 45),
                    }}
                    onClick={(props, marker) =>
                      OnMarkerClick(props, marker, element)
                    }
                  />
                );
              })}

              <InfoWindow
                visible={true}
                marker={activeMarker}
                onCloseClick={() => {
                  setSelectedElement(null);
                }}
              >
                <div
                  style={{
                    padding: "15px",
                    color: "#fff",
                    fontSize: "14px",
                    maxWidth: "550px",
                    textAlign: "left", // Align text to the left
                    borderRadius: "12px",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
                    border: "1px solid #fff",
                    lineHeight: "1.6",
                  }}
                >
                  {liveTripData?.trip_id ? (
                    <>
                      <h3
                        style={{
                          marginTop: 0,
                          marginBottom: "12px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#fbb136",
                        }}
                      >
                        🚗 Trip Details
                      </h3>

                      <div>
                        <strong>🆔 Trip ID:</strong> {liveTripData?.trip_id}
                      </div>
                      <div>
                        <strong>👤 Passenger Name :</strong>{" "}
                        {`${liveTripData?.passenger_info?.first_name} ${liveTripData?.passenger_info?.last_name}`}
                      </div>
                      <div>
                        <strong>👨‍✈️ Driver Name :</strong>{" "}
                        {`${selectedElement?.first_name} ${selectedElement?.last_name}`}
                      </div>
                      <div>
                        <strong>📍 Start :</strong>{" "}
                        {liveTripData?.pick_up?.location}
                      </div>
                      <div>
                        <strong>🏁 Destination :</strong>{" "}
                        {liveTripData?.drop_off?.at(-1)?.location || "N/A"}
                      </div>
                    </>
                  ) : (
                    <>
                      <h3
                        style={{
                          marginTop: 0,
                          marginBottom: "12px",
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#fbb136",
                        }}
                      >
                        Driver Info
                      </h3>
                      <div>
                        <strong>👨‍✈️ Name :</strong>{" "}
                        {`${selectedElement?.first_name} ${selectedElement?.last_name}`}
                      </div>
                      <div>
                        <strong>📧 Email :</strong>{" "}
                        {selectedElement?.email || "N/A"}
                      </div>
                      <div>
                        <strong>📱 Mobile :</strong>{" "}
                        {`${selectedElement?.mobile_country_code} ${selectedElement?.mobile}` ||
                          "N/A"}
                      </div>
                    </>
                  )}
                </div>
              </InfoWindow>
            </Map>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoogleApiWrapper({
  apiKey: configuration.webAPIKey,
})(MapContainer);
